enum OrderStatus {
  CREATED = 'created',
  PROCESSING = 'processing',
  NEW = 'new',
  CANCELED = 'canceled',
}

enum ActionsKeys {
  BUYER_ORDER = 'buyer_order',
  CONFIRM = '1',
  CANCEL = '2',
}

enum OrderPaymentStatus {
  CONFIRM = 1,
  CANCELED = 2,
  FAILED = 3,
}

enum BillingStatus {
  NOT_PAID = '0',
  PAID = '1',
  CANCELED = '2',
  POST_PAID = '3',
}

export { OrderStatus, ActionsKeys, OrderPaymentStatus, BillingStatus };
